import * as React from "react";
export const ChartGroupContextInt = React.createContext(undefined);
export function useChartGroupContext() {
    return React.useContext(ChartGroupContextInt);
}
//# sourceMappingURL=useChartGroupContext.js.map